/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LiveSessionItem } from '../../models/live-session-item';

export interface ApiLiveSessionItemIdGet$Params {
  item_id: number;
}

export function apiLiveSessionItemIdGet(http: HttpClient, rootUrl: string, params: ApiLiveSessionItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveSessionItem>> {
  const rb = new RequestBuilder(rootUrl, apiLiveSessionItemIdGet.PATH, 'get');
  if (params) {
    rb.path('item_id', params.item_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LiveSessionItem>;
    })
  );
}

apiLiveSessionItemIdGet.PATH = '/api/live_session/{item_id}';
